import { render, staticRenderFns } from "./SupplierVerificationInstruction.vue?vue&type=template&id=bafad3b2&"
import script from "./SupplierVerificationInstruction.vue?vue&type=script&lang=js&"
export * from "./SupplierVerificationInstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports